import FlexBox from "../components/layouts/Flexbox";
import { Stack, Typography } from "@mui/material";
import { APP_COLORS } from "../enums";
import { IMAGES_PATH } from "../constants";

export default function NoDataFound({
  message = "Records are not available at the moment.",
}) {
  return (
    <FlexBox alignItems="center">
      <img src={`${IMAGES_PATH}/no data found.png`} alt="No data found" />
      <Stack>
        <Typography variant="large-helveticaNeue" color={APP_COLORS.textMedium2}>
          No data found!
        </Typography>
        <Typography variant="body-ibmPlexMono" color={APP_COLORS.textLight2}>
          {message}
        </Typography>
      </Stack>
    </FlexBox>
  );
}
